// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";
import { RootState, useAppSelector } from "@root/src/slices/store";
import { getActiveRoutesV2, routes } from "@root/src/route";
import PreLoader from "@root/src/component/common/PreLoader";

const Link = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(function Link(itemProps, ref) {
  return <RouterLink ref={ref} {...itemProps} role={undefined} />;
});

export default function Error() {
  const auth = useAppSelector((state: RootState) => state.auth);
  const userRoutes = getActiveRoutesV2(routes, auth.roles);
  const routesReady = userRoutes && userRoutes.length > 0;

  if (auth.status === "loading" || !routesReady) return (
    <PreLoader isLoading={true} hideLogo={false} message={null} />
  );
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h1" style={{ color: "gray" }}>
        404
      </Typography>
      <Typography variant="h6" style={{ color: "gray" }}>
        The page you're looking for doesn't exist..
      </Typography>
      <Button component={Link} to={"/"} variant="contained">
        Back Home
      </Button>
    </Box>
  );
}
